import type { MatchRulesetDefinition } from './types';

export const STANDARD_RULESET: MatchRulesetDefinition = {
  id: 'standard-1v1',
  columns: 5,
  rows: 3,
  fortressHearts: 6,
  startEssence: 400,
  baseIncome: 0,
  summonBaseCost: 25,
  summonCostPerTower: 10,
  killReward: (rank) => Math.round(12 * Math.pow(1.5, rank - 1)),
  postPay: 1.5,
  bossDamageReward: 0.06,
  bossKillReward: 60,
  overtimeAt: 270,
  overtimeLeakMultiplier: 2,
  overtimeIncomeMultiplier: 1.5,
  overtimeSpeedMultiplier: 1.35,
  gate: { damage: 20, interval: 0.5, range: 150 },
  siege: { interval: 30, hp: 600, hpGrowth: 220, damage: 34, speed: 30, leak: 2 },
  hardEndAt: 390,
  laneCap: 14,
  flankReach: 200,
  maxRank: 5,
  eliteRank: 4,
  eliteLeak: 2,
  rankScaling: {
    towerDamage: 0.75,
    towerFireRate: 0.08,
    minionHp: 0.85,
    minionDamage: 0.75,
    spawnRate: 0.1,
  },
  lanes: {
    id: 'tap-to-toggle',
    name: 'Tap to toggle',
    mode: 'manual',
    switchCooldown: 0,
    mergeInheritance: 'destination',
  },
};

/**
 * Screen-space layout of the portrait board in logical pixels (540 x 960).
 * Lanes are vertical flanks beside both turret grids. They do not run under
 * the grids (see `lanes.ts`).
 */
export const LAYOUT = {
  width: 540,
  height: 960,
  topHud: { y: 0, h: 60 },
  enemyGrid: { x: 48, y: 72, tile: 84, gap: 6 },
  field: { y: 344, h: 160 },
  playerGrid: { x: 48, y: 512, tile: 84, gap: 6 },
  bottomHud: { y: 840, h: 120 },
  lanes: { x: [24, 516] as [number, number], width: 44, topY: 72, bottomY: 776 },
} as const;

/** Essence charged to drag a tower onto another cell in the painted-lane mode. */
export const PAINTED_MOVE_COST = 5;

export const GRID_WIDTH = LAYOUT.playerGrid.tile * 5 + LAYOUT.playerGrid.gap * 4;
export const GRID_HEIGHT = LAYOUT.playerGrid.tile * 3 + LAYOUT.playerGrid.gap * 2;
/** Open ground between the two grids, where the lanes bend inward. */
export const FIELD_BOTTOM = LAYOUT.field.y + LAYOUT.field.h;
export const FIELD_TOP = LAYOUT.field.y;
